<div class="interaction-row">
    @if(showToggleView) {
        <mat-button-toggle-group name="list type" aria-label="List Type" class="list-selector">
            <!-- TODO: al posto di (click) è forse meglio usare il (change): (change)="changeListType($event)" -->
            <mat-button-toggle value="tabella" (click)="changeListType(false)" checked>Tabella</mat-button-toggle>
            <mat-button-toggle value="card" (click)="changeListType(true)" class="reverse-toggle">Card</mat-button-toggle>
        </mat-button-toggle-group>
    }
    

    <!-- Altri attributi: 
        showFirstLastButtons -> per btn di navigazione
        -->
        @if(showPaginator) {
            <mat-paginator class="paginator"
            (page)="handlePageEvent($event)" 
            [pageIndex]="currentPage - 1" 
            [length]="totalItems"
            [pageSize]="currentPageSize" 
            [pageSizeOptions]="pageSizeOptions" 
            [hidePageSize]="true"
            aria-label="Seleziona la pagina">
            <!-- parametrizzare: aria-label(con traduttore) -->
        </mat-paginator>
        }
    
</div>

@if(totalItems > 0) {
    @if(showListCard) {
        <!-- TODO: gutterSize da token -->
        <mat-grid-list [cols]="gridColumns" gutterSize="24px" rowHeight="305px">  
            @for(item of dataSourceTable; track $index) {
                <mat-grid-tile (click)="handleRowClicked(item)">
                    <ng-container
                        *ngTemplateOutlet="gridItemTemplate; 
                        context: { itemData: item }">
                    </ng-container>
                </mat-grid-tile>
            }
        </mat-grid-list>

    } @else {
        <!-- 
        INFO FLAG:
            -matSortActive: matSortActive="titolo"
                definisce la colonna inizialmente attiva per l'ordinamento della tabella. 
                funziona solo se si è specificato il valore di [mat-sort-header] ai th.
                se stringa vuota == nussun ordinamento 
            -matSortDisableClear: [matSortDisableClear]="true"
                se true rimuove lo stato "clear/nessun ordinamento" dal comportamento: asc, disc e "clear"
            
        -->
                <mat-card appearance="elevated" class="table-container">
                    <mat-card-content>
                        <table mat-table [dataSource]="dataSourceTable"
                            matSort (matSortChange)="handleSortEvent($event)"
                            [matSortActive]="currentSortColumn" [matSortDirection]="currentSortDirection" >

                            @for (column of columnsInfo; track $index) {
                                <ng-container matColumnDef="{{column.columnNameDef}}">
                                    @if(column.sortable === true) {
                                        <th [ngClass]="{'text-one-line': column?.labelOnOneLine}" class="text-one-line label-large" mat-header-cell *matHeaderCellDef (click)="handleMultiSortEvent(column.columnNameDef)">
                                            <div class="table-header">
                                                {{column.label}}
                                                @if (isColumnSorted(column.columnNameDef)) {
                                                    @if (getSortDirection(column.columnNameDef) === 'asc') {
                                                        <!-- <mat-icon class="sort-custom-arrow">arrow_upward</mat-icon> -->
                                                        <i class="fa-regular fa-arrow-up sort-custom-arrow"></i>
                                                    }
                                                    @if (getSortDirection(column.columnNameDef) === 'desc') {
                                                        <!-- <mat-icon class="sort-custom-arrow">arrow_downward</mat-icon> -->
                                                        <i class="fa-regular fa-arrow-down sort-custom-arrow"></i>
                                                    }
                                                } @else {
                                                        <i class="fa-regular fa-arrow-down-arrow-up sort-custom-arrow"></i>
                                                }
                                            </div>
                                        </th>
                                    } @else {
                                        <th [ngClass]="{'text-one-line': column?.labelOnOneLine}" class="label-large" mat-header-cell *matHeaderCellDef> {{column.label}} </th>
                                    }
                                
                                    <td 
                                        mat-cell 
                                        *matCellDef="let element" 
                                        [class.cell-component]="column.type === TypeOfColumn.COMPONENT"
                                        [class.cell-text]="column.type !== TypeOfColumn.COMPONENT">
                                            @if(column.type === TypeOfColumn.TEXT) {
                                                <span class="cell-clamp-4">{{ element[column.columnNameDef] }}</span>
                                            } @else if (column.type === TypeOfColumn.DATE) {
                                                <!-- <div style="white-space: pre"> -->
                                                <div>
                                                <!-- {{ (element[column.columnNameDef] | date: 'dd/MM/yyyy' : 'it-IT') || '-' }} -->
                                                {{ (element[column.columnNameDef] | date: 'dd/MM/yyyy HH:mm' : 'UTC' ) || '-' }}
                                                </div>
                                            } @else if (column.type === TypeOfColumn.NUMBER) {
                                                {{ element[column.columnNameDef] | translocoDecimal : {
                                                  useGrouping: true,
                                                  minimumFractionDigits: column.minimumFractionDigits,
                                                  maximumFractionDigits: column.maximumFractionDigits
                                                } }}
                                            } @else if (column.type === TypeOfColumn.COMPONENT) {
                                                <!-- Nel componente estendere la classe ListPageColumnComponent-->
                                                <ng-component *ngComponentOutlet="column.component; inputs: { itemData: element, infoColumn: column, _reloadData: reloadDataEmitter }" />
                                            } @else if (column.type === TypeOfColumn.CURRENCY) {
                                              {{ element[column.columnNameDef] | translocoCurrency: 'symbol' : {
                                                useGrouping: true,
                                                minimumFractionDigits: column.minimumFractionDigits,
                                                maximumFractionDigits: column.maximumFractionDigits
                                              } }}
                                            } @else if (column.type === TypeOfColumn.DETAIL) {
                                                <i class="fa-regular fa-chevron-right"></i>
                                            }
                                    </td>
                                </ng-container>
                            }
                            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                            <tr mat-row *matRowDef="let item; columns: displayedColumns;" (click)="handleRowClicked(item)"></tr>
                        </table>
                    </mat-card-content>
                </mat-card>
    }
} @else if(totalItems == 0) {
    <!-- Caso di nessun elemento -->
    <span class="title-small empty-message-container">
        {{'Nessun risultato presente'}}
    </span>
}
